export default "__VITE_ASSET__D2GFaTqT__"